<!-- 2 = ReportFormatEnum.ScenarioComparison -->
<ng-container *ngIf="impactItems?.reportFormatId == 2 && impactItems?.componentItems?.length > 0">
  <div class="table-content">
    <table class="table">
      <thead>
        <tr>
          <td *ngFor="let item of impactItems?.componentItems[0]?.componentName?.split(';')">
            {{ item }}
          </td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of impactItems?.componentItems?.length; let i = index">
          <td>
            <span style="padding-right: 15px">{{ impactItems?.componentItems[p]?.name }}</span>
          </td>
          <td *ngFor="let item of impactItems?.componentItems[i]?.impactValues?.split(';')">
            <span style="color: black">{{ item }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- need to add chart -->
</ng-container>

<!-- 3 = ReportFormatEnum.FullReport -->
<ng-container
  *ngIf="
    (impactItems?.reportFormatId == 3 || impactItems?.reportFormatId == 11) &&
    impactItems?.componentItems?.length > 0
  "
>
  <div
    *ngIf="
      impactItems?.componentItems?.length > 0 && impactItems.isExport;
      else other_check_isExport
    "
  >
    <!-- ReportTypeEnum.ContributionbyProductLosses = 17 -->
    <!-- ReportTypeEnum.ContributionbyPackagingLevel = 16 -->
    <!-- ReportTypeEnum.ContributionofTransport = 20 -->
    <div
      *ngIf="
        impactItems?.reportTypeId == 17 ||
          impactItems?.reportTypeId == 16 ||
          impactItems?.reportTypeId == 20;
        else other_checked_reportType
      "
    >
      <div class="table-content" *ngIf="impactItems?.componentItems?.length > 0">
        <table class="table">
          <thead>
            <tr>
              <td></td>
              <td *ngFor="let item of impactItems?.componentItems[0]?.componentName?.split(';')">
                {{ item }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let p of impactItems?.componentItems; let i = index">
              <td>
                <span style="padding-right: 15px">{{ p?.name }}</span>
              </td>
              <td *ngFor="let item of p.impactValues?.split(';')">
                <span style="color: black">{{ item | decimalFormatPipe }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <ng-template #other_checked_reportType>
      <ng-container *ngIf="impactItems?.componentItems?.length > 0">
        <div class="table-content">
          <table class="table">
            <thead>
              <tr>
                <td>{{ reportResource.lblIndicator }}</td>
                <td *ngFor="let item of impactItems?.componentItems?.length">
                  {{ item.componentName }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let p of impactItems?.componentItems[0]?.indicators?.split(';');
                  let i = index
                "
              >
                <td>
                  <span style="padding-right: 15px">{{ p }}</span>
                </td>
                <td *ngFor="let item of impactItems.componentItems[i]?.impactValues?.split(';')">
                  <span style="color: black">{{ item | decimalFormatPipe }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
    </ng-template>
  </div>
  <ng-template #other_check_isExport>
    <div *ngIf="impactItems.componentItems.length > 0">
      <!-- ReportTypeEnum.ContributionbyProductLosses = 17 -->
      <!-- ReportTypeEnum.ContributionbyPackagingLevel = 16 -->
      <!-- ReportTypeEnum.ContributionofTransport = 20 -->
      <div
        *ngIf="
          impactItems?.reportTypeId == 17 ||
            impactItems?.reportTypeId == 16 ||
            impactItems?.reportTypeId == 20;
          else other_checked_reportTypeSecond
        "
      >
        <div class="table-content">
          <table class="table">
            <thead>
              <tr>
                <td></td>
                <td *ngFor="let item of impactItems.componentItems[0]?.componentName?.split(';')">
                  {{ item }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let p of impactItems?.componentItems; let i = index">
                <td>
                  <span style="padding-right: 15px">{{ p?.name }}</span>
                </td>
                <td *ngFor="let item of impactItems.componentItems[i].impactValues.split(';')">
                  <span style="color: black">{{ item | decimalFormatPipe }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <ng-template #other_checked_reportTypeSecond>
        <div class="table-content" *ngIf="impactItems?.componentItems?.length > 0">
          <table class="table">
            <thead>
              <tr>
                <td>{{ reportResource.lblIndicator }}</td>
                <td *ngFor="let item of impactItems?.componentItems">
                  {{ item?.componentName }}
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let p of impactItems?.componentItems[0]?.indicators?.split(';');
                  let i = index
                "
              >
                <td>
                  <span style="padding-right: 15px">{{ p }}</span>
                </td>
                <td *ngFor="let item of impactItems.componentItems[i]?.impactValues?.split(';')">
                  <span style="color: black">{{ item | decimalFormatPipe }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-template>
    </div>
  </ng-template>
  <ng-container *ngIf="!isIsoReport">
    <br />
    <br />
  </ng-container>
  <div class="chartDesign">
    <div class="chartDesign" *ngIf="isIsoReport">
      <p class="content-figure uniqFigureSeq">
        {{ impactItems?.indicatorName }} comparison
        {{ reportResource.lblPackingLevelStage }}
        -
        {{ impactItems?.functionalUnitName | lowercase }} is shown in figure #1.
      </p>
    </div>
    <ng-container *ngIf="isIsoReport">
      <br />
      <br />
    </ng-container>

    <div *ngIf="impactItems.isExport" class="fullReportChart">
      <piqet-angular-bar-chart
        [chartData]="componentItemsArrayForChart"
        [chartOpacity]="chartOpacity"
        [indicatorsName]="indicatorsName"
        [chartType]="generatedChartType"
        [isChartNormalized]="false"
      ></piqet-angular-bar-chart>
    </div>
    <div *ngIf="!impactItems.isExport" class="fullReportChart">
      <piqet-angular-bar-chart
        [chartData]="componentItemsArrayForChart"
        [chartOpacity]="chartOpacity"
        [indicatorsName]="indicatorsName"
        [chartType]="generatedChartType"
        [isChartNormalized]="false"
      ></piqet-angular-bar-chart>
    </div>
  </div>
</ng-container>
